/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.2",
    versionName: "0.2.0-nightly.2026.1.2",
    versionChannel: "nightly",
    buildDate: "2026-01-02T00:07:45.759Z",
    commitHash: "ecd06ab30ce4657a543733d252f10ca7e276ca0d",
};
